<template>
  <span>
    <b-dropdown
      v-if="order"
      ref="dropdown"
      aria-role="list"
      position="is-bottom-left"
      append-to-body
    >
      <template #trigger="{ active }">
        <b-button
          :loading="loading"
          size="is-small"
          :icon-left="minimal ? 'currency-usd' : ''"
          :type="minimal ? get(value).color : ''"
          :icon-right="active ? 'chevron-up' : 'chevron-down'"
        >
          <template v-if="!minimal">
            <span :class="['is-circle', get(value).color]" />
            {{ get(value).text }}
          </template>
        </b-button>
      </template>
      <b-dropdown-item :focusable="false" aria-role="menu-item" custom>
        <div class="buttons buttons-center">
          <b-button
            v-for="row in statuses"
            :key="row"
            size="is-small-1"
            class="is-fullwidth"
            @click="changeStatus(row)"
          >
            <span :class="['is-circle', get(row).color]" />
            {{ get(row).text }}
          </b-button>
        </div>
      </b-dropdown-item>
    </b-dropdown>
    <!-- KLIENT -->
    <div v-else class="order-status-tag">
      <b-icon v-if="!noIcon" icon="payment" size="is-small" />
      <span class="tag" :class="get(value).color">
        {{ get(value).text }}
      </span>
    </div>
  </span>
</template>

<script>
import statusesMap from '~/marketplace-front-core/mixin/statusesMap'

export default {
  mixins: [statusesMap],
  props: {
    value: {
      type: String,
      default: null
    },
    minimal: {
      type: Boolean
    },
    noIcon: {
      type: Boolean
    },
    order: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      statuses: ['PROGRESS', 'COMPLETED', 'CANCELED']
    }
  },
  methods: {
    changeStatus (status) {
      if (status === 'COMPLETED' && this.order.amountNeeded && this.order.amountNeeded > 0) {
        this.modal({
          type: 'PAYMENT_STATUS',
          status: 'COMPLETED',
          order: this.order,
          amount: this.order.amountNeeded
        })
      } else {
        this.loading = true
        this.$refs.dropdown.toggle()
        this.$api.admin.order.payment(this.order.id, status)
          .then((res) => {
            this.loading = false
            this.$buefy.toast.open({
              message: this.$t('admin.orderDetails.changePaymentStatus.success'),
              type: 'is-success'
            })
            this.$emit('input', res.status)
          })
          .catch(() => {
            this.loading = false
            this.$buefy.toast.open({
              message: this.$t('admin.orderDetails.changePaymentStatus.error'),
              type: 'is-danger'
            })
          })
      }
    },
    get (status) {
      if (status && status.includes('STATUS_SURCHARGE_REQUIRE')) {
        return {
          color: 'is-dark-orange',
          text: this.$t('statuses.STATUS_SURCHARGE_REQUIRE')
        }
      } else if (status && status.includes('STATUS_ORDER_INCOMPLETED')) {
        return {
          color: 'is-warning is-stripe',
          text: this.$t('statuses.STATUS_ORDER_INCOMPLETED')
        }
      } else if (status && status.includes('STATUS_REFUND_ALL')) {
        return {
          color: 'is-danger is-stripe',
          text: this.$t('statuses.STATUS_REFUND_ALL')
        }
      } else if (status && status.includes('COMPLETED')) {
        return {
          color: 'is-success',
          text: this.$t('statuses.COMPLETED')
        }
      } else if (status && status.includes('CANCELED')) {
        return {
          color: 'is-danger',
          text: this.$t('statuses.CANCELED')
        }
      } else if (status && status.includes('EXPIRED')) {
        return {
          color: 'is-danger',
          text: this.$t('statuses.EXPIRED')
        }
      } else if (status && status.includes('MOLLIE_AUTHORIZED')) {
        return {
          color: 'is-bulma',
          text: this.$t('statuses.MOLLIE_AUTHORIZED')
        }
      } else if (status && status.includes('NOT_COMPLETE')) {
        return {
          color: 'is-success is-stripe',
          text: this.$t('statuses.NOT_COMPLETE')
        }
      } else if (status && status.includes('PAID_USING_TRADE_CREDIT')) {
        return {
          color: 'is-success is-stripe',
          text: this.$t('statuses.PAID_USING_TRADE_CREDIT')
        }
      } else if (status && status.includes('STATUS_COMPLETED_TC')) {
        return {
          color: 'is-success is-stripe',
          text: this.$t('statuses.STATUS_COMPLETED_TC')
        }
      } else {
        return {
          color: 'is-warning',
          text: this.$t('statuses.PROGRESS')
        }
      }
    },
    modal (data, element = this) {
      const nameModal = 'setAmountModal'
      if (element.$refs[nameModal]) {
        element.$refs[nameModal].open(data)
      } else if (element.$parent) {
        this.modal(data, element.$parent)
      }
    }
  }
}
</script>
